export const locales: string[] = ['da', 'de', 'en', 'pl'];
